import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_ADMIN = 'LOAD_ADMIN'
export const DELETE_ADMIN = 'DELETE_ADMIN'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    administradores: null,
    ready: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_ADMIN] ({ commit, state }) {
    commit(SET_STATE, { ready: false })
    api.listEntidade('admin').then(
      administradores => {
        commit(SET_STATE, { administradores, ready: true })
      },
    )
  },
  async [BOOTSTRAP] ({ dispatch, commit, state }) {
    await dispatch(LOAD_ADMIN)
  },
  async [DELETE_ADMIN] ({ dispatch, commit, state }, administrador) {
    const index = state.administradores.findIndex(c => c.id === administrador.id)

    Swal.fire({
      title: 'Tem certeza que deseja excluir o Administrador?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('admin', administrador.id).then(
          result => result,
          () => {
            Swal.fire({
              icon: 'error',
              title: 'Ocorreu algum erro!',
              text: 'Não foi possivel excluir o Administrador!',
            })
          },
        )
      },
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'O Administrador foi excluído com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2500,
        })
        state.administradores.splice(index, 1)
        api.listEntidade('admin').then(result => {
          state.administradores = result
        })
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
